// @ts-nocheck TODO: fix types for the entire file

import styled, { StyledComponent } from '@emotion/styled';
import { Tooltip as MuiTooltip, TooltipProps } from '@mui/material';
import { Box } from '@mui/system';
import { IconButton as ThemeIconButton } from 'components/Buttons';
import { CustomIcon, CustomIconProps } from 'components/CustomIcon';
import MBSelect from 'components/Forms/MBSelect/MBSelect';
import MBTextField from 'components/Forms/MBTextField/MBTextField';
import { CloseIcon as MuiCloseIcon } from 'icons';
import pxToEm from 'theme/pxToEm';

export const Field = styled(MBTextField)`
  width: 100%;
  display: flex;
  .MuiOutlinedInput-root {
    border-radius: ${pxToEm(24)};
    background-color: ${({ theme }) => theme.palette.grey[50]};
    border-color: ${({ theme }) => theme.palette.grey[50]};
    height: ${pxToEm(48)};

    &:hover,
    &.Mui-focused {
      .MuiInputAdornment-root:first-of-type svg {
        color: ${({ theme }) => theme.palette.primary.main};
      }
    }

    & fieldset {
      border: none !important;
    }
  }
`;

export const AiSearchButton = styled.button`
  align-items: center;
  background: transparent;
  border: 0;
  color: ${({ theme }) => theme.palette.grey.A400};
  cursor: pointer;
  display: inline-flex;
  height: ${pxToEm(32)};
  justify-content: center;
  margin-left: ${pxToEm(2)};
  margin-right: ${pxToEm(12)};
  padding: 0;
  width: ${pxToEm(32)};

  &[hidden] {
    display: none !important;
  }

  svg {
    color: inherit;
    display: block;
    height: ${pxToEm(20)};
    width: ${pxToEm(20)};
  }

  &:hover {
    color: ${({ theme }) => theme.palette.grey[800]};
  }

  &:focus-visible {
    border-radius: 999px;
    outline: 2px solid ${({ theme }) => theme.palette.primary.main};
    outline-offset: 2px;
  }
`;

export const SearchIcon: React.FC<
  React.PropsWithChildren<CustomIconProps>
> = styled(CustomIcon)`
  cursor: pointer;
  color: ${({ theme }) => theme.palette.grey.A400};
  margin-right: ${pxToEm(6)};
  &:hover {
    color: ${({ theme }) => theme.palette.grey[800]};
  }
`;

export const CloseIcon = styled(MuiCloseIcon)`
  cursor: pointer;
  width: ${pxToEm(20)};
  color: ${({ theme }) => theme.palette.grey.A400};
  margin-right: 14px;
  &:hover {
    color: ${({ theme }) => theme.palette.grey[800]};
  }
`;

export const FormWrapper = styled(Box)`
  display: flex;
  align-items: center;
  border-radius: ${pxToEm(24)};
  background-color: ${({ theme }) => theme.palette.grey[50]};
  border-color: ${({ theme }) => theme.palette.grey[50]};
`;

export const Select = styled(MBSelect)`
  margin-right: 1em;
`;

export const Tooltip: StyledComponent<TooltipProps> = styled(MuiTooltip, {
  shouldForwardProp: (prop) => !['isNewFeature'].includes(prop),
})`
  & ~ .MuiTooltip-popper {
    .MuiTooltip-tooltip {
      margin-top: 0.5em;
      max-width: ${pxToEm(200, false, 12)};
      background: ${({ theme, isNewFeature }) =>
        isNewFeature ? '#e6fa0a' : theme.palette.primary.main};
      color: ${({ theme, isNewFeature }) =>
        isNewFeature ? theme.palette.primary.main : theme.palette.common.white};
      padding: 0 16px;
      white-space: nowrap;
      min-height: ${({ isNewFeature }) => (isNewFeature ? '26px' : '40px')};
      border-radius: ${({ isNewFeature }) => (isNewFeature ? '16px' : '20px')};
      text-align: center;
      font-size: 16px;
      position: relative;
      .MuiTooltip-arrow {
        position: absolute;
        top: 5px;
        left: 50%;
        margin-left: -8px;
        color: ${({ isNewFeature }) => (isNewFeature ? '#e6fa0a' : '#4D4E58')};
      }
      span {
        white-space: pre-wrap;
        font-size: 16px;
      }
    }
    z-index: 200;
  }
`;

export const ImageSearchWrapper = styled.div``;

export const ImageSearchButton = styled(ThemeIconButton)`
  cursor: pointer;
  background: ${({ theme }) => theme.palette.common.white};
  padding: 8px;
  position: relative;
  right: 8px;
  svg {
    margin: 0;
    width: 1.25em;
  }
  &:hover {
    background: ${({ theme }) => theme.palette.grey['300']};
  }
`;

export const TooltipContainer = styled.div`
  position: relative;
  width: 38px;
`;
